"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MapperBuilder_1 = require("./MapperBuilder");
const map_status_to_value_1 = require("../map-status-to-value");
class Contract extends MapperBuilder_1.default {
    constructor() {
        super();
        this.colors = {};
        this.setStatus({
            INPROGRESS: 'in_progress',
            BUILDING: 'building',
            APPROVED: 'approved',
            EXPIRED: 'expired',
            CANCELED: 'canceled',
        });
        this.setTranslations({
            [this.statusList.INPROGRESS]: 'Em andamento',
            [this.statusList.BUILDING]: 'Em construção',
            [this.statusList.APPROVED]: 'Aprovado',
            [this.statusList.EXPIRED]: 'Vencido',
            [this.statusList.CANCELED]: 'Cancelado',
        });
        this.setAssertions({
            isInProgress: this.buildAssertFunc(this.statusList.INPROGRESS),
            isBuilding: this.buildAssertFunc(this.statusList.BUILDING),
            isApproved: this.buildAssertFunc(this.statusList.APPROVED),
            isExpired: this.buildAssertFunc(this.statusList.EXPIRED),
            isCanceled: this.buildAssertFunc(this.statusList.CANCELED),
        });
        this.setColors({
            [this.statusList.INPROGRESS]: '#7dff7d',
            [this.statusList.BUILDING]: '#ffcf7d',
            [this.statusList.APPROVED]: '#7dfffc',
            [this.statusList.EXPIRED]: '#fb7b7b',
            [this.statusList.CANCELED]: '#fb7bd1',
        });
    }
    toMapperInterface() {
        const result = super.toMapperInterface();
        result.color = (status) => map_status_to_value_1.default(status, this.colors);
        return result;
    }
    setColors(colors) {
        this.colors = colors;
        this.markItemAsFilled('colors');
    }
}
exports.default = Contract;
//# sourceMappingURL=Contract.js.map